import React, { Fragment, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import posed from 'react-pose';
import css from '../style.css';
import AdNetworkSelection from './AdNetworkSelection';
import { Button } from '../../components/widgets';

const Z_INDEX = { SHOW: 3, HIDE: 0 };
const AnimationItem = posed.div({
    enter: {
        opacity: 1,
        zIndex: 5,
        x: 0,
        transition: {
            x: {
                type: 'tween',
                duration: 200,
                ease: 'anticipate',
            },
        },
    },
    exit: {
        opacity: 0,
        zIndex: 3,
        x: 150,
        transition: {
            x: {
                type: 'spring',
                duration: 0,
            },
        },
    },
});

const AddNewUan = ({
    adNetworkOptions = [],
    selectedAdNetworkOption = {},
    onAdNetworkSelectionChange,
    buttonText = '',
    placeholderText = '',
    onInputChange = () => {},
    icon = null,
}) => {
    const [showAdNetworkSelection, setShowAdNetworkSelection] = useState(false);

    const showAdNetworkSelectionHandler = useCallback(
        element => {
            if (element && element.currentTarget.id === 'uanNameText' && !showAdNetworkSelection) {
                return;
            }
            setShowAdNetworkSelection(true);
        },
        [showAdNetworkSelection]
    );

    const hideAdNetworkSelectionHandler = useCallback(() => {
        setShowAdNetworkSelection(false);
    }, []);

    return (
        <Fragment>
            <AnimationItem pose={showAdNetworkSelection ? 'enter' : 'exit'} style={{ zIndex: Z_INDEX.SHOW }}>
                <div
                    id="uanNameText"
                    className={css.uanNameText}
                    onBlur={hideAdNetworkSelectionHandler}
                    style={{
                        width: '300px',
                        marginRight: '-1px',
                        right: showAdNetworkSelection ? 0 : '',
                        zIndex: showAdNetworkSelection ? Z_INDEX.SHOW : Z_INDEX.HIDE,
                    }}
                >
                    <AdNetworkSelection
                        onChange={onAdNetworkSelectionChange}
                        onBlur={hideAdNetworkSelectionHandler}
                        options={adNetworkOptions}
                        controlledValue={selectedAdNetworkOption}
                        placeHolder={placeholderText}
                        onInputChange={onInputChange}
                        setFocus={showAdNetworkSelection}
                    />
                </div>
            </AnimationItem>
            <Button
                onClick={showAdNetworkSelectionHandler}
                onBlur={hideAdNetworkSelectionHandler}
                type="primary"
                level="level1"
                text={buttonText}
                forceActive={showAdNetworkSelection}
                style={{ borderRadius: showAdNetworkSelection ? '0 2px 2px 0' : '2px', zIndex: 4 }}
                Icon={icon}
            />
        </Fragment>
    );
};

AddNewUan.propTypes = {
    adNetworkOptions: PropTypes.arrayOf(PropTypes.any),
    selectedAdNetworkOption: PropTypes.objectOf(PropTypes.any),
    buttonText: PropTypes.string,
    placeholderText: PropTypes.string,
    onInputChange: PropTypes.func,
    onAdNetworkSelectionChange: PropTypes.func.isRequired,
    icon: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({
            component: PropTypes.func,
        }),
    ]),
};

export default AddNewUan;
